<script lang="ts">
    import { Link } from "@inertiajs/svelte";
    export let subNavigationItems:{ route: string, title: string }[];
    import { t } from "@lernetz/svelte-translate";
</script>

<div class=" sm:ml-32 lg:ml-48 flex items-stretch">
    {#each subNavigationItems as item}
        <Link href="{item.route}">
            <div class="mx-8 border-light-grey border-b-4 flex items-center h-full hover:border-primary">
                <span class="px-16 text-primary text-center">{$t(item.title)}</span>
            </div>
        </Link>
    {/each}
</div>
